import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { L10nLocale, L10nTranslationService, L10N_LOCALE } from 'angular-l10n';
import { Association } from '../../hickory-api';
import { AssociationType, PagedAssociationValues } from '../association-types/association-type';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-select-association-values',
  templateUrl: './select-association-values.component.html',
  styleUrls: ['./select-association-values.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class SelectAssociationValuesComponent implements OnInit {
  @Input() set association(association: Association) {
    this._association = association;
    this.values = null;
  }
  @Input() set valuesService(value: AssociationType) {
    this._valuesService = value;
    if (value) {
      this.updateValues();
    }
  }
  @Input() showButton: boolean = true;
  @Input() showModal?: Observable<any>;
  @Output() updated = new EventEmitter<Association>();
  @Output() done = new EventEmitter<any>();
  titleOptions: any = {
    'Asset.Id': 'AssetIdTitle',
    'Asset.ExternalId': 'AssetExternalIdTitle',
    'Group.Id': 'Association.Filter.Groups',
    'Group.ExternalId': 'Association.Filter.Groups',
    'User.Id': 'Association.Filter.Users',
    'User.ExternalId': 'Association.Filter.Users'
  };
  _association: Association = null;
  get association() {
    return this._association;
  }
  _valuesService: AssociationType;
  get valuesService() {
    return this._valuesService;
  }
  get title(): string {
    const titleId = this.titleOptions[this.association.key];
    return titleId ? this.translation.translate(titleId) : this.association.key.slice(this.association.key.indexOf('.') + 1);
  }
  loadFailed: boolean;
  values: any[];
  search: string = '';
  page: number = 1;
  pageSize: number = 10;
  count: number = 0;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private translation: L10nTranslationService) {
  }

  ngOnInit() {
    // listen for when this modal is (re-)displayed and clear the "search" value
    this.showModal?.subscribe(() => this.search = '');
  }

  apply() {
    this.updated.emit(this.association);
    this.done.emit();
    this.search = '';
    return false;
  }

  onSearchChanged(matchString: string) {
    this.search = matchString;
    this.page = 1;
    this.updateValues();
  }

  onPageChanged(page: number) {
    this.page = page;
    this.updateValues();
  }

  updateValues() {
    this.loadFailed = false;
    this.valuesService.getValues(this.page, this.pageSize, this.search).subscribe((p: PagedAssociationValues) => {
      this.values = p.items;
      this.count = p.totalItemCount;
    }, err => {
      this.loadFailed = true;
    });
  }
  manageValues(value: string) {
    const idx = this.association.values.indexOf(value);
    if (idx === -1) {
      this.association.values.push(value);
    } else {
      this.association.values.splice(idx, 1);
    }
    this.updated.emit(this.association);
  }
  selectAll(values: any[]) {
    const selected = this.association.values;
    values.forEach(function (v) {
      if (!(selected as any).includes(v.value)) {
        selected.push(v.value);
      }
    });
    this.association.values = selected;
    this.updated.emit(this.association);
  }
  clearPage(values: any[]) {
    this.search= '';
    const selected = this.association.values;
    values.forEach(function (v) {
      for (let i = 0, len = selected.length; i < len; i++) {
        if (selected[i] === v.value) {
          selected.splice(i, 1);
          break;
        }
      }
    });
    this.association.values = selected;
    this.updated.emit(this.association);
  }
  isSelectedCheck(value: any) {
    return this.association.values.some(v => v === value);
  }
}
